import { render, staticRenderFns } from "./FormAddMID.vue?vue&type=template&id=18ac2a27&scoped=true&"
import script from "./FormAddMID.vue?vue&type=script&lang=ts&"
export * from "./FormAddMID.vue?vue&type=script&lang=ts&"
import style0 from "./FormAddMID.vue?vue&type=style&index=0&id=18ac2a27&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac2a27",
  null
  
)

export default component.exports